import { createContext, useContext } from 'react';

import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';

import { Hint } from './Hint';

interface FocusModeValue {
    focusMode: boolean;
    toggleFocusMode: () => void;
}

/** Provided by the file page; without it the button is not rendered. */
export const FocusModeContext = createContext<FocusModeValue | null>(null);

/** Hides the app sidebar by letting the page cover the window. */
export function FocusModeButton() {
    const value = useContext(FocusModeContext);
    if (!value) return null;
    const { focusMode, toggleFocusMode } = value;
    const Icon = focusMode ? PanelLeftOpen : PanelLeftClose;
    const label = focusMode ? 'Show sidebar' : 'Hide sidebar';
    return (
        <Hint text={label}>
            <button
                type="button"
                aria-label={label}
                aria-pressed={focusMode}
                className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-[#CBE1E1] hover:bg-[#EFF9F9]"
                onClick={toggleFocusMode}
                data-testid="GroundTruthPreview__focusModeButton"
            >
                <Icon aria-hidden="true" className="h-4 w-4" />
            </button>
        </Hint>
    );
}
